import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a3d92f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "checkbox-display" }
const _hoisted_4 = {
  key: 0,
  icon: "check",
  class: "check-icon",
  width: "13",
  height: "10",
  viewBox: "0 0 13 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M4.59517 7.7342L11.314 1.01541C11.4297 0.899737 11.567 0.840651 11.726 0.838149C11.8851 0.83566 12.0249 0.894746 12.1456 1.01541C12.2662 1.13605 12.3266 1.27465 12.3266 1.4312C12.3266 1.58775 12.2662 1.72635 12.1456 1.84701L5.08725 8.90532C4.94665 9.04592 4.78263 9.11621 4.59517 9.11621C4.40771 9.11621 4.24368 9.04592 4.10309 8.90532L0.855865 5.65812C0.740197 5.54245 0.683108 5.40509 0.684599 5.24605C0.686102 5.08701 0.747178 4.94716 0.867824 4.82652C0.988483 4.70586 1.12708 4.64553 1.28362 4.64553C1.44018 4.64553 1.57878 4.70586 1.69942 4.82652L4.59517 7.7342Z",
  fill: "white",
  stroke: "white"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "checkbox-label" }

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleCheckbox',
  props: {
  checked: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    default: ""
  }
},
  emits: ["update:checked"],
  setup(__props, { emit }) {

const props = __props;



// イベント


// 内部状態
const innerChecked = ref(props.checked);
const inputEl = ref<HTMLInputElement | null>(null);

// propsの変更を監視して内部状態を更新
watch(
  () => props.checked,
  newVal => {
    innerChecked.value = newVal;
  }
);

// クリックハンドラ
function handleClick(e: MouseEvent): void {
  innerChecked.value = !innerChecked.value;
  emit("update:checked", innerChecked.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "custom-checkbox",
    onClick: _withModifiers(handleClick, ["stop"])
  }, [
    _createElementVNode("input", {
      ref_key: "inputEl",
      ref: inputEl,
      type: "checkbox",
      checked: innerChecked.value,
      class: "hidden-checkbox",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, null, 8, _hoisted_2),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["checkbox-box", { checked: innerChecked.value }])
      }, [
        (innerChecked.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true)
      ], 2),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(__props.label), 1)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})